import React from "react";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";

import "./Header.css";

import {
  useLanguage,
} from "../context/LanguageContext";
import creteImage from "../assets/images/crete-logo-new.png";
import l1 from "../assets/images/english.png";
import l2 from "../assets/images/netherlands.png";
import wpimg from "../assets/images/whatsapp.png";
function Header() {

  // =====================================================
  // LANGUAGE CONTEXT
  // =====================================================

  const {
    language,
    t,
    switchLanguage,
  } = useLanguage();

  // =====================================================
  // CURRENT LANGUAGE
  // =====================================================

  const activeLangId =
    Number(language?.lang_id || 1);

  // =====================================================
  // LANGUAGE CHANGE
  // =====================================================

  const handleLanguageChange = async (
    langId
  ) => {

    if (
      Number(langId) ===
      activeLangId
    ) {
      return;
    }

    try {

      console.log(
        "CLICKED LANGUAGE:",
        langId
      );

      const data =
        await switchLanguage(
          Number(langId)
        );

      console.log(
        "LANGUAGE UPDATED:",
        data
      );

      toast.success(
        `Language changed to ${data.lang_name}`
      );

    } catch (error) {

      console.error(
        "Language change error:",
        error
      );

      toast.error(
        "Failed to change language"
      );

    }
  };

  return (
    <nav
      className="
        navbar
        navbar-expand-lg
        navbar-dark
        ftco_navbar
        bg-dark
        ftco-navbar-light
      "
      id="ftco-navbar"
    >

      <div className="container">

        {/* =====================================================
            LOGO
        ====================================================== */}

        <Link
          className="navbar-brand"
          to="/"
        >
          <img
          src={creteImage}
            alt="Crete Holidays Logo"
          />
        </Link>

        {/* =====================================================
            TOP LANGUAGE FLAGS
        ====================================================== */}

        <div className="social2">

          {/* ENGLISH */}

          <div
            className="flag1"
            style={{
              opacity:
                activeLangId === 1
                  ? 1
                  : 0.5,
            }}
          >

            <a
              href="#"
              onClick={(e) => {

                e.preventDefault();

                handleLanguageChange(1);

              }}
            >

              <img
                src="/images/english.png"
                alt="English"
                style={{
                  width: "100%",
                  margin: "0px",
                }}
              />

            </a>

          </div>

          {/* NEDERLANDS */}

          <div
            className="flag2"
            style={{
              opacity:
                activeLangId === 2
                  ? 1
                  : 0.5,
            }}
          >

            <a
              href="#"
              onClick={(e) => {

                e.preventDefault();

                handleLanguageChange(2);

              }}
            >

              <img
                src="/images/netherlands.png"
                alt="Nederlands"
                style={{
                  width: "100%",
                  margin: "0px",
                }}
              />

            </a>

          </div>

        </div>

        {/* =====================================================
            MOBILE BUTTON
        ====================================================== */}

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#ftco-nav"
          aria-controls="ftco-nav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >

          <span className="oi oi-menu"></span>

          <span className="ms-1">
            Menu
          </span>

        </button>

        {/* =====================================================
            MENU
        ====================================================== */}

        <div
          className="
            collapse
            navbar-collapse
          "
          id="ftco-nav"
        >

          <ul className="navbar-nav">

            {/* HOME */}

            <li className="nav-item active">

              <Link
                to="/"
                className="nav-link"
              >
                {t(
                  "menu.menu0",
                  "Home"
                )}
              </Link>

            </li>

            {/* ABOUT */}

            <li className="nav-item">

              <Link
                to="/about"
                className="nav-link"
              >
                {t(
                  "menu.menu4",
                  "About us"
                )}
              </Link>

            </li>

            {/* OUR CARS */}

            <li className="nav-item">

              <Link
                to="/ourcars"
                className="nav-link"
              >
                {t(
                  "menu.menu2",
                  "Our car"
                )}
              </Link>

            </li>

            {/* BOOK A CAR */}

            <li className="nav-item">

              <Link
                to="/booking"
                className="nav-link"
              >
                {t(
                  "menu.menu1",
                  "Book a car"
                )}
              </Link>

            </li>

            {/* MODIFY */}

            <li className="nav-item">

              <Link
                to="/modify-reservation"
                className="nav-link"
              >
                {t(
                  "menu.menu3",
                  "Modify Reservation"
                )}
              </Link>

            </li>

            {/* SPECIAL OFFER */}

            <li className="nav-item">

              <Link
                to="/special-offer"
                className="nav-link"
              >
                {t(
                  "menu.menu14",
                  "Special offer"
                )}
              </Link>

            </li>

            {/* CONTACT */}

            <li className="nav-item">

              <Link
                to="/contact"
                className="nav-link"
              >
                {t(
                  "menu.menu6",
                  "Contact us"
                )}
              </Link>

            </li>

          </ul>

        </div>

        {/* =====================================================
            RIGHT SIDE
        ====================================================== */}

        <div className="social">

          {/* ENGLISH */}

          <div
            className="flag1"
            style={{
              opacity:
                activeLangId === 1
                  ? 1
                  : 0.5,
            }}
          >

            <a
              href="#"
              onClick={(e) => {

                e.preventDefault();

                handleLanguageChange(1);

              }}
            >

              <img
                src={l1}
                alt="English"
                style={{
                  width: "100%",
                  margin: "0px",
                }}
              />

            </a>

          </div>

          {/* NETHERLANDS */}

          <div
            className="flag2"
            style={{
              opacity:
                activeLangId === 2
                  ? 1
                  : 0.5,
            }}
          >

            <a
              href="#"
              onClick={(e) => {

                e.preventDefault();

                handleLanguageChange(2);

              }}
            >

              <img
                src={l2}
                alt="Nederlands"
                style={{
                  width: "100%",
                  margin: "0px",
                }}
              />

            </a>

          </div>

          {/* WHATSAPP */}

          <div className="wpnumber">

            <a
              href="https://wa.me/3197010204725"
              target="_blank"
              rel="noopener noreferrer"
            >

              <img
                src={wpimg}
                alt="WhatsApp"
                style={{
                  width: "17%",
                }}
              />

              <span
                style={{
                  lineHeight: "34px",
                }}
              >
                +319-7010204725
              </span>

            </a>

          </div>

        </div>

      </div>

    </nav>
  );
}

export default Header;